// CLARTEXT · Dev-only-Gate für Preview-Routen (Sep 2026).
// Erstes Dev-only-Muster im Frontend (vorher keins vorhanden — geprüft).
// Freigeschaltet NUR auf: localhost, *.preview.emergentagent.com oder per
// explizitem Override REACT_APP_ENABLE_DEV_PREVIEW=true. In Produktion
// (clartext.io) ist die Route damit nicht registriert und der bestehende
// Catch-All (`<Route path="*" element={<Navigate to="/" />}>`) greift.
export function isDevPreviewEnabled() {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return true;
  if (host.endsWith(".preview.emergentagent.com")) return true;
  return process.env.REACT_APP_ENABLE_DEV_PREVIEW === "true";
}
